import { render, staticRenderFns } from "./RecruitAdd.vue?vue&type=template&id=781cd34e&scoped=true"
import script from "./RecruitAdd.vue?vue&type=script&lang=js"
export * from "./RecruitAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781cd34e",
  null
  
)

export default component.exports